import { api } from "./api";

// ─── Types ────────────────────────────────────────────────────────────────────

export interface Categorie {
  categoriaId: number;
  nombreEspanol: string;
  nombreIngles: string;
  usuarioActualizacion?: string;
  activo: boolean;
}

export interface CategoriePayload {
  nombreEspanol: string;
  nombreIngles: string;
  activo?: boolean; // 👉 Habilitamos que pueda viajar el booleano al backend
}

// ─── Service ──────────────────────────────────────────────────────────────────

const ENDPOINT = "/admin/categories";

export const categoriesService = {
  getAll: () => api.get<Categorie[]>(ENDPOINT),

  insert: (payload: CategoriePayload) => api.post<Categorie>(ENDPOINT, payload),

  update: (id: number, payload: CategoriePayload) =>
    api.put<Categorie>(`${ENDPOINT}/${id}`, payload),

  delete: (id: number) => api.delete(`${ENDPOINT}/${id}`),
};

// Public endpoint
export const fetchPublicCategories = () => api.get<Categorie[]>("/categories");
